<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h2>
          {{$t('followUp.subtitle')+$store.state.form.resultJson.userInfos.firstname + " " + $store.state.form.resultJson.userInfos.lastname}}</h2>
        <h1>{{$t('followUp.title')}}</h1>
      </div>
    </div>
    <div class="row listOfButtons">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((level == 'high') ? 'bg-color' : '')"
                @click="level='high'">{{$t('followUp.high')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((level == 'veryHigh') ? 'bg-color' : '')"
                @click="level='veryHigh'">{{$t('followUp.veryHigh')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((level == 'highest') ? 'bg-color' : '')"
                @click="level='highest'">{{$t('followUp.highest')}}
        </button>
      </div>
    </div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('choiceCriteria.title')}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('space') !== false) ? 'bg-color' : '')"
                @click="addToArray('space')">{{$t('choiceCriteria.space')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('atmosphere') !== false) ? 'bg-color' : '')"
                @click="addToArray('atmosphere')">{{$t('choiceCriteria.atmosphere')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('equipment') !== false) ? 'bg-color' : '')"
                @click="addToArray('equipment')">{{$t('choiceCriteria.equipment')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('price') !== false) ? 'bg-color' : '')"
                @click="addToArray('price')">{{$t('choiceCriteria.price')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('followUp') !== false) ? 'bg-color' : '')"
                @click="addToArray('followUp')">{{$t('choiceCriteria.followUp')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('cleanliness') !== false) ? 'bg-color' : '')"
                @click="addToArray('cleanliness')">{{$t('choiceCriteria.cleanliness')}}
        </button>
      </div>
    </div>
    <div class="row separatedRow">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('parking') !== false) ? 'bg-color' : '')"
                @click="addToArray('parking')">{{$t('choiceCriteria.parking')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('proximity') !== false) ? 'bg-color' : '')"
                @click="addToArray('proximity')">{{$t('choiceCriteria.proximity')}}
        </button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((isInArray('diversity') !== false) ? 'bg-color' : '')"
                @click="addToArray('diversity')">{{$t('choiceCriteria.diversity')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col overFooter">
        <button type="submit"
                :class="'btn btn-primary alignRight ' + ((returnChoiceList.length > 0 && level !== '') ? 'bg-color' : '')"
                @click="saveData()">{{$t('general.next')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'choice-criteria',
  data () {
    return {
      level: '',
      returnChoiceList: [],
      maxChoice: 3
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {
      layout: 'ChoiceCriteria',
      isAuthorized: (this.returnChoiceList.length > 0 && this.level !== ''),
      data: this.dataTosave
    });
  },
  methods: {
    saveData: function () {
      if (this.returnChoiceList.length > 0 && this.level !== '') {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
      }
    },
    isInArray: function (item) {
      var returnPosOrFalse = false;
      for (var i = 0; i < this.returnChoiceList.length; i++) {
        if (this.returnChoiceList[i] === item) {
          returnPosOrFalse = i;
        }
      }
      return returnPosOrFalse;
    },
    addToArray: function (item) {
      var posOrFalse = this.isInArray(item);
      if (posOrFalse === false) {
        if (this.returnChoiceList.length < this.maxChoice) {
          this.returnChoiceList.push(item);
        }
      } else {
        this.returnChoiceList.splice(posOrFalse, 1);
      }
    }
  },
  computed: {
    dataTosave: function () {
      return {
        choiceCriteria: {
          followUp: this.level,
          choiceList: [...this.returnChoiceList]
        }
      };
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/ChoiceCriteria.vue